import React from "react";

const useCallPatient = () => {
  const [isOpen, setOpen] = React.useState(false);

  const open = () => setOpen(true);

  const close = () => setOpen(false);

  return {
    isCallPatientOpen: isOpen,
    openCallPatient: open,
    closeCallPatient: close,
  };
};

export default useCallPatient;
